import { memo as Memo, useEffect, useRef, useState } from 'react';
import ArrowStyle from './style';

const ArrowBtnLink = Memo(({ animate, className, speed = '2s', delay = 0, diapason = ['10deg', '-15deg'], type = 'center' }) => {
	const svgRef = useRef(null);
	const [size, setSize] = useState({ width: 0, height: 0 });
	const [active, setActive] = useState(false);

	useEffect(() => {
		if (!svgRef.current) return;

		const observer = new ResizeObserver(([entry]) => {
			if (entry?.contentRect) {
				setSize({
					width: entry.contentRect.width,
					height: entry.contentRect.height,
				});
			}
		});

		observer.observe(svgRef.current);

		const bbox = svgRef.current.getBoundingClientRect();
		setSize({ width: bbox.width, height: bbox.height });

		return () => {
			observer.disconnect();
		};
	}, []);

	useEffect(() => {
		if (animate) {
			if (delay > 0) {
				const t = setTimeout(() => setActive(true), delay);
				return () => clearTimeout(t);
			} else {
				setActive(true);
			}
		} else {
			setActive(false);
		}
	}, [animate, delay]);

	return (
		<ArrowStyle
			className={`${className ? className : ''}`}
			$speed={speed}
			$diapason={diapason}>
			<div
				style={{ width: size.width, height: size.height }}
				className='arrow-inner-all-wrap'>
				<div
					className={`wrapper ${active ? 'swing' : ''}`}
					style={{ width: size.width, height: size.height }}>
					{type === 'left' ? (
						<svg
							ref={svgRef}
							className='svg-max'
							viewBox='0 0 337.21 194.22'
							preserveAspectRatio='none'>
							<path d='M214.1,38.06c-36.79-5.14-69.86-2.83-98.28,6.86A147.59,147.59,0,0,0,56.67,82.21a153.93,153.93,0,0,0-33,51.8L10.47,107.45,3.31,111l16.11,32.34,3.26,7.22L61.55,133l-3.29-7.29L30.73,138.17a147,147,0,0,1,32-50.67,139.8,139.8,0,0,1,56-35.09C145.81,43.2,177.56,41,213,46l4,.55,1.1-7.92Z' />
							<path
								id='path'
								strokeWidth='8px'
								fill='none'
								stroke='none'
								d='M148.42,36.08C127.27,39.66,104,47.64,82.5,64.3A149.62,149.62,0,0,0,63.28,82.18'
							/>
						</svg>
					) : type === 'right' ? (
						<svg
							ref={svgRef}
							className='svg-max'
							preserveAspectRatio='none'
							viewBox='0 0 177.29 228.41'>
							<path d='M154.11,172.13l-2.94-7.44-19.38,7.64a116.13,116.13,0,0,0,6.83-43.39C136.84,78.63,102,44.73,73,25.16l-3.31-2.24L65.2,29.54l3.31,2.24c39.75,26.87,60.64,59.53,62.11,97.07a108.94,108.94,0,0,1-6.62,41.4L115.54,151l-7.33,3.22,13.6,31,6.21-2.73Z' />
							<path
								stroke='none'
								fill='none'
								d='M122.45,82.65a108.64,108.64,0,0,1,10.12,29,104.5,104.5,0,0,1,1.45,27'
							/>
						</svg>
					) : (
						<svg
							ref={svgRef}
							viewBox='0 0 280 98.5'>
							<path
								d='M270.7,34.8v48.6c-19.1-23.7-42.5-43.6-69-58.6C174,9.4,144.7,1,114.7,0.2C77.3-1.1,38.6,9.4,0,31l4.6,8.2
          C71.8,1.4,136.5-0.7,196.7,32.8c34.2,19,57.2,44.8,66.6,56.4h-47.6v9.3H280V34.8H270.7z'
							/>
						</svg>
					)}
				</div>
			</div>
		</ArrowStyle>
	);
});

export default ArrowBtnLink;
